<template>
  <router-link :data-bs-toggle="collapse ? 'collapse' : ''" :to="collapse ? `#${collapseRef}` : `/${collapseRef}`"
    :aria-controls="collapseRef" :aria-expanded="isExpanded" class="nav-link"
    :class="isActive ? 'active bg-success' : ''" v-bind="$attrs" @click="isExpanded = !isExpanded">
    <div class="text-center d-flex align-items-center justify-content-center" :class="stIsRTL ? ' ms-2' : 'me-2'">
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="stIsRTL ? ' me-1' : 'ms-1'"
      :style="{ opacity: isCollapsed ? 0 : 1, width: isCollapsed ? 0 : 'auto', overflow: isCollapsed ? 'hidden' : 'visible' }">{{
        navText
      }}</span>
  </router-link>
  <div :class="isExpanded ? 'collapse show' : 'collapse'">
    <slot name="list"></slot>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "SidenavCollapse",
  props: {
    collapseRef: {
      type: String,
      required: true
    },
    navText: {
      type: String,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    },
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    // ...mapState(["isRTL", "color"])
    ...mapGetters(["stIsRTL", "stColor", "stLastActiveSideNavRoute"]),
    isActive() {
      const currentPath = this.$route.path;
      const itemPath = `/${this.collapseRef}`;

      // Exact match - return true (last active is set in router guard)
      if (currentPath === itemPath) {
        return true;
      }

      // If no match found, check if this was the last active route
      // This keeps the previous item highlighted when navigating to other pages
      const lastActive = this.stLastActiveSideNavRoute;
      
      return lastActive === this.collapseRef;
    }
  },
  mounted() {
    // On mount, if current route matches, set as last active
    const currentPath = this.$route.path;
    const itemPath = `/${this.collapseRef}`;

    if (currentPath === itemPath) {
      this.$store.commit('SET_LAST_ACTIVE_SIDE_NAV_ROUTE', this.collapseRef);
    }
  }
};
</script>

<style scoped>
.nav-link.active {
  background-color: #28a745 !important;
  color: #fff !important;
}

.nav-link.active .nav-link-text {
  color: #fff !important;
}
</style>
